import React from "react";
import styles from "./FareCardRefundability.module.scss";
import {
  BlockContentValue,
  UnstyledBlockContent
} from "../UnstyledBlockContent/UnstyledBlockContent";
import clsx from "clsx";

export type FareCardRefundabilityProps = {
  content?: BlockContentValue;
  isRefundable: boolean;
  className?: string;
};

export const FareCardRefundability: React.FC<FareCardRefundabilityProps> = ({
  isRefundable,
  content,
  className
}) => {
  return (
    <div
      className={clsx(
        styles.refundability,
        {
          [styles.refundabilityRefundable]: isRefundable
        },
        className
      )}
    >
      <UnstyledBlockContent value={content} />
    </div>
  );
};
